/* eslint-disable import/prefer-default-export */
import { getCurrentInstance, SetupContext, computed } from 'vue';
import Toast from 'vant/lib/toast';
import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import { formateNum, copyToClipboard } from '@/common/utils';
import { AIFeed, AIFeedLiked, AIFeedApiService } from '@/api/ai-feed';
import { AIFeedPageEnum } from '@/store/modules/ai-feed';
import { AIActionType, AIActionBarProps } from './ai_common';
import { UserInfoByLogin } from '@/api/user';
import AIChatLocalizeService from '../../../scripts/ai-chat';
/*
 * SEO 环境的配置，social-ai需要
 */

export const AIActionBarSeoSetup = (props: AIActionBarProps, ctx: SetupContext<Array<'onChangeLoginPopupVisible'>>) => {
    const { proxy } = getCurrentInstance() as { proxy: any };
    const { addLike, addUnlike, isBotLikedByUser } = AIChatLocalizeService();
    const userInfoByLogin = computed<UserInfoByLogin>(() => {
        const userInfoByLogin = (proxy?.$store?.state?.userModule?.userInfo || {}) as UserInfoByLogin;
        return userInfoByLogin;
    });

    const handleLikeAction = debounce(async (type: AIActionType) => {
        const feedLikeStatus = type === AIActionType.Like ? AIFeedLiked.Like : AIFeedLiked.UnLike;
        props.aiFeed.liked = feedLikeStatus;
        const { user, userId, user_id } = userInfoByLogin.value || {};
        const uid = userId || user_id || user?.user_id || Cookies.get('userId');
        if (feedLikeStatus === AIFeedLiked.Like) {
            await addLike(props?.aiFeed);
        } else {
            await addUnlike(props?.aiFeed);
        }

        // const res = await AIFeedApi.changeAIFeedLikedStatus(
        //     {
        //         cancel: feedLikeStatus === AIFeedLiked.UnLike,
        //         botId: props?.aiFeed?.bot_id_str,
        //     },
        //     {
        //         params: {
        //             'kwaipro.pwa_ph': Cookies.get('kwaipro.pwa_ph'),
        //         },
        //     }
        // );
        // if (res?.result !== 1) {
        //     if (res?.result === 109) {
        //         // eslint-disable-next-line vue/require-explicit-emits
        //         ctx.emit('onChangeLoginPopupVisible', true);
        //         return;
        //     }

        //     res?.error_msg &&
        //         Toast({
        //             message: res?.error_msg,
        //         });
        //     return;
        // }

        // const newFeedList = feedList.value?.map?.(feed => {
        //     if (feed.bot_id_str === props?.aiFeed?.bot_id_str) {
        //         return {
        //             ...feed,
        //             liked: feedLikeStatus,
        //         };
        //     }
        //     return feed;
        // });
        // proxy?.$store?.commit?.('aiFeedMoudle/resetFeedList', props.feedPage);
        // proxy?.$store?.commit?.('aiFeedMoudle/setFeedList', {
        //     [props?.feedPage || AIFeedPageEnum.AIForyou]: newFeedList || [],
        // });
    }, 300);

    const handleShareAction = debounce(async (url: string) => {
        copyToClipboard(url);
        Toast({
            message: proxy?.$root?.$t?.('k_446636'),
        });
    }, 300);

    const handleSwitchChatModeAction = debounce(async (history: Boolean) => {
        proxy?.$bus.emit('switchChatMode', props.aiFeed, history);
    }, 300);

    const likeCount = (count: number) => {
        return formateNum(count || 0).toString();
    };

    const shareCount = (count: number) => {
        return formateNum(count || 0).toString();
    };

    const likeStatus = computed(() => {
        const res = isBotLikedByUser(props?.aiFeed);
        return res ? AIFeedLiked.UnLike : AIFeedLiked.Like;
    });

    const isShareButtonEnabled = computed(() => {
        return true;
    });

    return {
        handleLikeAction,
        handleShareAction,
        likeStatus,
        handleSwitchChatModeAction,
        isShareButtonEnabled,

        likeCount,
        shareCount,
    };
};
